import {
	type UseTitleGenerationOnPasteProps,
	useTitleGenerationOnPaste,
} from './hooks/useTitleGenerationOnPaste.tsx';

export const TitleGenerationOnPaste = ({
	contentId,
	contentType,
	textAreaRef,
	title,
	isLivePage,
	isEditorEmpty,
	userOffline,
	flags,
	i18n,
	formatMessage,
	onTitleGenerated,
	onTitleGeneratingChange,
}: UseTitleGenerationOnPasteProps) => {
	useTitleGenerationOnPaste({
		contentId,
		contentType,
		textAreaRef,
		title,
		isLivePage,
		isEditorEmpty,
		userOffline,
		flags,
		i18n,
		formatMessage,
		onTitleGenerated,
		onTitleGeneratingChange,
	});

	return null;
};
